import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/icons/student.png'
import _imports_1 from '@/assets/img/icons/demenageur.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "page",
  itemscope: "",
  itemtype: "https://schema.org/FAQPage"
}
const _hoisted_3 = { id: "left" }
const _hoisted_4 = { class: "filter-inputs" }
const _hoisted_5 = { class: "filter" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "size" }, "Filtrer par surface", -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<option value=\"all\">Toutes les tailles</option><option value=\"0-4\">Entre 0 et 4 m²</option><option value=\"4-8\">Entre 4 et 8 m²</option><option value=\"8-15\">Entre 8 et 15 m²</option><option value=\"15-999\">Plus de 15 m²</option>", 5)
const _hoisted_12 = [
  _hoisted_7
]
const _hoisted_13 = { class: "filter" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Filtrer par type de stockage", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "all" }, "Tous les types", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "indoor" }, "Box intérieur", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "outdoor" }, "Box extérieur", -1)
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "filter" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "carton" }, "Vente de carton ?", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "all" }, "-", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "yes" }, "Oui", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "filter" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "promo" }, "Promotion en cours ?", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "all" }, "-", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "yes" }, "Oui", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  style: {"margin-top":"0.5em"}
}
const _hoisted_30 = {
  key: 1,
  style: {"margin-top":"0.5em"}
}
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = {
  key: 5,
  class: "search-sentence more"
}
const _hoisted_34 = ["aria-expanded"]
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Voir plus ")
const _hoisted_36 = { style: {"text-align":"center"} }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Nous avons trouvé ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" résultats correspondants à vos filtres de recherche ")
const _hoisted_39 = { id: "gm-block" }
const _hoisted_40 = { class: "gm-item" }
const _hoisted_41 = { class: "search-gm" }
const _hoisted_42 = { class: "no-mobile" }
const _hoisted_43 = ["href"]
const _hoisted_44 = ["src", "alt"]
const _hoisted_45 = {
  key: 1,
  src: "https://www.location-gardemeuble.fr/img/no-img.gif",
  alt: "Aucune image disponible pour ce garde-meuble"
}
const _hoisted_46 = {
  key: 0,
  class: "green-promo",
  style: {"background":"#35388A","margin":"0.8em auto","font-size":"0.8em","padding":"0.5em"}
}
const _hoisted_47 = ["href"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.location-gardemeuble.fr/img/rdv.png",
  alt: "RDV",
  width: "280",
  height: "224",
  style: {"position":"relative","top":"0"}
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "Prendre RDV", -1)
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = ["href"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("b", null, "Voir les tailles de box et les tarifs", -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = ["href"]
const _hoisted_58 = { class: "gm-icons" }
const _hoisted_59 = {
  class: "no-mobile",
  style: {"height":"30px","text-align":"left","font-size":"0.65em"}
}
const _hoisted_60 = {
  key: 0,
  class: "green-promo",
  style: {"background":"#35388A","font-size":"1em !important"}
}
const _hoisted_61 = ["title"]
const _hoisted_62 = ["title"]
const _hoisted_63 = ["title"]
const _hoisted_64 = ["title"]
const _hoisted_65 = { class: "gm-icons only-mobile" }
const _hoisted_66 = { style: {"display":"flex !important","margin":"0.1em auto 0.2em"} }
const _hoisted_67 = ["title"]
const _hoisted_68 = ["title"]
const _hoisted_69 = ["title"]
const _hoisted_70 = ["title"]
const _hoisted_71 = {
  key: 0,
  class: "only-mobile",
  style: {"font-size":"0.7em","margin-top":"0.60em"}
}
const _hoisted_72 = {
  key: 0,
  class: "only-mobile",
  style: {"font-size":"0.7em","margin-top":"0.4em","line-height":"175%"}
}
const _hoisted_73 = {
  key: 1,
  class: "only-mobile",
  style: {"font-size":"0.7em","margin-top":"0.4em","line-height":"175%"}
}
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  class: "only-mobile",
  style: {"font-size":"0.7em","margin-top":"0.4em"}
}
const _hoisted_76 = {
  key: 1,
  class: "stars only-mobile",
  style: {"margin-top":"0.4em","margin-bottom":"0"}
}
const _hoisted_77 = ["href", "onClick"]
const _hoisted_78 = { style: {"position":"relative","top":"-2px","text-decoration":"none"} }
const _hoisted_79 = { style: {"font-size":"1em","text-decoration":"underline","padding":"0"} }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_81 = { class: "gm-infos" }
const _hoisted_82 = { class: "no-mobile" }
const _hoisted_83 = {
  class: "no-mobile",
  style: {"margin-top":"0.4em"}
}
const _hoisted_84 = {
  key: 0,
  class: "stars no-mobile"
}
const _hoisted_85 = ["href", "onClick"]
const _hoisted_86 = { class: "no-mobile" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { style: {} }, " Avis complet ", -1)
const _hoisted_88 = { class: "grey" }
const _hoisted_89 = ["innerHTML"]
const _hoisted_90 = {
  key: 2,
  id: "box-table"
}
const _hoisted_91 = ["href"]
const _hoisted_92 = ["innerHTML"]
const _hoisted_93 = /*#__PURE__*/_createTextVNode()
const _hoisted_94 = ["innerHTML"]
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = {
  key: 0,
  class: "promo"
}
const _hoisted_97 = { key: 0 }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("b", null, " Voir tarif ", -1)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { class: "textPrice" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("small", null, " TTC / mois ", -1)
const _hoisted_103 = {
  key: 0,
  style: {"text-decoration":"line-through","font-size":"0.75em"}
}
const _hoisted_104 = { style: {"text-align":"right","margin-top":"0.4em"} }
const _hoisted_105 = ["href"]
const _hoisted_106 = /*#__PURE__*/_createElementVNode("b", null, "Voir les tarifs", -1)
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = { class: "pagination" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","padding":"1em","border":"1px solid #DDDDDD","font-weight":"bold"} }, " Aucun résultat ne correspond aux filtres sélectionnés. ", -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = { class: "city-info" }
const _hoisted_113 = { style: {"margin-bottom":"2.5em"} }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("h3", null, " Questions fréquentes ", -1)
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "faq" }
const _hoisted_117 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_118 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_119 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_120 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_121 = /*#__PURE__*/_createTextVNode(" à ")
const _hoisted_122 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" et les tarifs varient de ")
const _hoisted_124 = /*#__PURE__*/_createElementVNode("b", null, " à ", -1)
const _hoisted_125 = /*#__PURE__*/_createTextVNode(" par mois. ")
const _hoisted_126 = { key: 0 }
const _hoisted_127 = {
  key: 0,
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_128 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_129 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_130 = { key: 0 }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("a", {
  href: "/calculateur-de-volume",
  rel: "canonical"
}, "calculateur en ligne", -1)
const _hoisted_132 = /*#__PURE__*/_createTextVNode(" pour trouver la bonne taille de box. Consultez les prix en temps réel sur le site Location-gardemeuble.fr. ")
const _hoisted_133 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_134 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_135 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_136 = { style: {"padding-left":"20px","text-align":"justify"} }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("b", null, "Consultez les disponibilités :", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Sélectionnez un box :"),
  /*#__PURE__*/_createTextVNode(" Une fois que vous avez trouvé un box qui répond à vos besoins, sélectionnez-le pour obtenir plus d'informations et vérifier sa disponibilité. ")
], -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("b", null, "Réservez en ligne :", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("b", null, "Signez le contrat de location :", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Payez le loyer :"),
  /*#__PURE__*/_createTextVNode(" Réglez le loyer pour la période de stockage choisie conformément aux modalités de paiement. ")
], -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("b", null, "Organisez votre déménagement :", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("b", null, "Accédez à votre box :", -1)
const _hoisted_144 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_145 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_146 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_147 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_148 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_149 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_150 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_151 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_152 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_153 = /*#__PURE__*/_createElementVNode("ul", { style: {"padding-left":"20px","text-align":"justify"} }, [
  /*#__PURE__*/_createElementVNode("li", null, " Articles inflammables ou explosifs, tels que les produits chimiques, les combustibles, les feux d'artifice, etc. "),
  /*#__PURE__*/_createElementVNode("li", null, " Substances dangereuses, telles que les produits toxiques, les pesticides, les acides, etc. "),
  /*#__PURE__*/_createElementVNode("li", null, " Animaux vivants ou plantes. "),
  /*#__PURE__*/_createElementVNode("li", null, " Aliments périssables ou non emballés. "),
  /*#__PURE__*/_createElementVNode("li", null, " Objets illégaux ou volés. "),
  /*#__PURE__*/_createElementVNode("li", null, " Objets de grande valeur, tels que l'argent, les bijoux, les œuvres d'art précieuses, à moins que vous n'ayez souscrit une assurance spécifique pour les couvrir. "),
  /*#__PURE__*/_createElementVNode("li", null, " Matériaux fragiles ou précieux qui pourraient être endommagés par la chaleur, l'humidité ou les variations de température. ")
], -1)
const _hoisted_154 = { key: 1 }
const _hoisted_155 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_156 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_157 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_158 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_159 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_160 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_161 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_162 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_163 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_164 = /*#__PURE__*/_createTextVNode(" Les promotions ou réductions sont-elles disponibles pour les nouveaux clients ? ")
const _hoisted_165 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_166 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_167 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_168 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_169 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_170 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_171 = { style: {"padding-left":"20px","text-align":"justify"} }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Paiement par carte bancaire :"),
  /*#__PURE__*/_createTextVNode(" Ils acceptent les paiements par carte de débit ou de crédit, ce qui offre une option pratique et sécurisée pour régler le loyer. ")
], -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Prélèvement automatique :"),
  /*#__PURE__*/_createTextVNode(" Ils proposent des options de prélèvement automatique où le montant du loyer est automatiquement débité de votre compte bancaire à chaque période de facturation. ")
], -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("b", null, "Virement bancaire :", -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("b", null, "Chèque :", -1)
const _hoisted_176 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_177 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_178 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_179 = { style: {"padding-left":"20px","text-align":"justify"} }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("b", null, "La taille du box : ", -1)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("b", null, "La localisation :", -1)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("b", null, "La durée de la location : ", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("b", null, "Les services et les installations :", -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("b", null, "Les promotions et les réductions :", -1)
const _hoisted_185 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_186 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_187 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_188 = { style: {"padding-left":"20px","text-align":"justify"} }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("b", null, "Saisonnalité :", -1)
const _hoisted_190 = /*#__PURE__*/_createElementVNode("b", null, "Offres spéciales :", -1)
const _hoisted_191 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Demande locale :"),
  /*#__PURE__*/_createTextVNode(" La demande de garde-meubles peut également varier en fonction de la région ou de la ville. Dans les zones urbaines densément peuplées où l'espace de stockage est limité, les tarifs de location peuvent être plus élevés en raison de la demande accrue. ")
], -1)
const _hoisted_192 = /*#__PURE__*/_createElementVNode("b", null, "Événements spéciaux :", -1)
const _hoisted_193 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_194 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_195 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_196 = { style: {"padding-left":"20px","text-align":"justify"} }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Coût de la vie :"),
  /*#__PURE__*/_createTextVNode(" Les tarifs de location peuvent être plus élevés dans les zones où le coût de la vie est plus élevé. Cela peut inclure les grandes villes ou les zones métropolitaines où les loyers et les prix de l'immobilier sont généralement plus élevés. ")
], -1)
const _hoisted_198 = /*#__PURE__*/_createElementVNode("b", null, "Demande locale :", -1)
const _hoisted_199 = /*#__PURE__*/_createElementVNode("b", null, "Taille du marché :", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("b", null, "Services et installations :", -1)
const _hoisted_201 = /*#__PURE__*/_createTextVNode(" Il est donc conseillé de comparer les tarifs avec le site Location-gardemeuble.fr et les services proposés par différents centres de self-stockage dans votre région pour trouver celui qui correspond le mieux à vos besoins et à votre budget. ")
const _hoisted_202 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_203 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_204 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_205 = { style: {"padding-left":"20px","text-align":"justify"} }
const _hoisted_206 = /*#__PURE__*/_createElementVNode("b", null, "Tarifs pour les entreprises :", -1)
const _hoisted_207 = /*#__PURE__*/_createElementVNode("b", null, "Tarifs de gros :", -1)
const _hoisted_208 = /*#__PURE__*/_createElementVNode("b", null, "Tarifs à long terme :", -1)
const _hoisted_209 = /*#__PURE__*/_createElementVNode("b", null, "Offres promotionnelles :", -1)
const _hoisted_210 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_211 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_212 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_213 = { style: {"padding-left":"20px","text-align":"justify"} }
const _hoisted_214 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Accès aux installations de sécurité :"),
  /*#__PURE__*/_createTextVNode(" Cela peut inclure l'accès aux caméras de surveillance, aux systèmes d'alarme et aux dispositifs de verrouillage des portes pour assurer la sécurité des biens entreposés. ")
], -1)
const _hoisted_215 = /*#__PURE__*/_createElementVNode("b", null, "Équipements de manutention :", -1)
const _hoisted_216 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Services supplémentaires :"),
  /*#__PURE__*/_createTextVNode(" Certains proposent des services supplémentaires inclus dans les tarifs, tels que la réception de livraisons, la mise à disposition de matériel d'emballage ou d'autres services logistiques. ")
], -1)
const _hoisted_217 = /*#__PURE__*/_createElementVNode("b", null, "Accès aux installations :", -1)
const _hoisted_218 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_219 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_220 = {
  itemprop: "text",
  style: {"line-height":"140%"}
}
const _hoisted_221 = { style: {"padding-left":"20px","text-align":"justify"} }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("b", null, "Assurance fournie par le fournisseur :", -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("b", null, "Options d'assurance supplémentaires :", -1)
const _hoisted_224 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Évaluation de la valeur des biens :"),
  /*#__PURE__*/_createTextVNode(" Avant de souscrire une assurance supplémentaire, il est recommandé d'évaluer la valeur de vos biens stockés. Cela vous aidera à déterminer le niveau de couverture nécessaire pour protéger adéquatement vos biens. ")
], -1)
const _hoisted_225 = /*#__PURE__*/_createElementVNode("b", null, "Coût de l'assurance :", -1)
const _hoisted_226 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Exigences en matière de documentation :"),
  /*#__PURE__*/_createTextVNode(" Certains fournisseurs peuvent exiger une documentation détaillée sur les biens assurés, tels que des inventaires ou des évaluations de la valeur des biens, avant de souscrire une assurance supplémentaire. ")
], -1)
const _hoisted_227 = /*#__PURE__*/_createTextVNode(" Pour faciliter vos démarches, vous pouvez aussi ")
const _hoisted_228 = {
  href: "https://www.assurmonbox.fr/?utm_source=location-gardemeuble.fr",
  target: "_blank",
  rel: "nofollow noopener"
}
const _hoisted_229 = /*#__PURE__*/_createTextVNode(", avec un courtier spécialisé. ")
const _hoisted_230 = { key: 1 }
const _hoisted_231 = { class: "faq" }
const _hoisted_232 = {
  key: 0,
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_233 = ["onClick"]
const _hoisted_234 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_235 = ["innerHTML"]
const _hoisted_236 = { key: 2 }
const _hoisted_237 = { class: "faq" }
const _hoisted_238 = {
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_239 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_240 = ["innerHTML"]
const _hoisted_241 = { key: 3 }
const _hoisted_242 = { class: "faq" }
const _hoisted_243 = {
  key: 0,
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_244 = ["onClick"]
const _hoisted_245 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_246 = ["innerHTML"]
const _hoisted_247 = { key: 4 }
const _hoisted_248 = { class: "faq" }
const _hoisted_249 = {
  key: 0,
  itemscope: "",
  itemprop: "mainEntity",
  itemtype: "https://schema.org/Question",
  class: "faq"
}
const _hoisted_250 = ["onClick"]
const _hoisted_251 = {
  itemscope: "",
  itemprop: "acceptedAnswer",
  itemtype: "https://schema.org/Answer"
}
const _hoisted_252 = ["innerHTML"]
const _hoisted_253 = { class: "stats" }
const _hoisted_254 = { key: 0 }
const _hoisted_255 = { style: {"font-size":"1.1em"} }
const _hoisted_256 = { style: {"margin":"1em 0"} }
const _hoisted_257 = { key: 0 }
const _hoisted_258 = /*#__PURE__*/_createTextVNode(" Le prix moyen d’un box de stockage à ")
const _hoisted_259 = /*#__PURE__*/_createTextVNode(" est de ")
const _hoisted_260 = /*#__PURE__*/_createTextVNode(" par mois par m")
const _hoisted_261 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_262 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_263 = { key: 1 }
const _hoisted_264 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_265 = /*#__PURE__*/_createTextVNode(" Le prix moyen d’un box de stockage dans le département ")
const _hoisted_266 = /*#__PURE__*/_createTextVNode(" est de ")
const _hoisted_267 = /*#__PURE__*/_createTextVNode(" par mois par m")
const _hoisted_268 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_269 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_270 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_271 = /*#__PURE__*/_createTextVNode(" Le prix moyen d’un box de stockage dans la région ")
const _hoisted_272 = /*#__PURE__*/_createTextVNode(" est de ")
const _hoisted_273 = /*#__PURE__*/_createTextVNode(" par mois par m")
const _hoisted_274 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_275 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_276 = /*#__PURE__*/_createTextVNode(" Les prix sont donnés à titre indicatif et peuvent varier en fonction de la taille du box, de la localisation et des services proposés. ")
const _hoisted_277 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_278 = { key: 0 }
const _hoisted_279 = { style: {"font-size":"1.1em"} }
const _hoisted_280 = { style: {"margin":"1em 0"} }
const _hoisted_281 = /*#__PURE__*/_createTextVNode(" En ")
const _hoisted_282 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_283 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_284 = { key: 1 }
const _hoisted_285 = { key: 0 }
const _hoisted_286 = { style: {"font-size":"1.1em"} }
const _hoisted_287 = { style: {"margin":"1em 0"} }
const _hoisted_288 = /*#__PURE__*/_createTextVNode(" Les dates sont données à titre indicatif et peuvent varier en fonction de la taille du box, de la localisation et des services proposés. ")
const _hoisted_289 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_290 = { key: 1 }
const _hoisted_291 = { style: {"font-size":"1.1em"} }
const _hoisted_292 = { style: {"margin":"1em 0"} }
const _hoisted_293 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_294 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_295 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_296 = /*#__PURE__*/_createTextVNode(" Les dates sont données à titre indicatif et peuvent varier en fonction de la taille du box, de la localisation et des services proposés. ")
const _hoisted_297 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_298 = { class: "city-badge" }
const _hoisted_299 = ["href", "title"]
const _hoisted_300 = {
  key: 0,
  class: "miniform only-mobile",
  id: "links"
}
const _hoisted_301 = /*#__PURE__*/_createElementVNode("h3", null, "Besoin de cartons de déménagement à prix imbattable ?", -1)
const _hoisted_302 = ["href"]
const _hoisted_303 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.location-gardemeuble.fr/img/logo_carton.jpg",
  alt: "Cartons de Déménagement",
  width: "250",
  height: "83"
}, null, -1)
const _hoisted_304 = /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " Vos cartons de déménagement pas chers, livrés chez vous en 24 heures ", -1)
const _hoisted_305 = /*#__PURE__*/_createElementVNode("div", { class: "fleche" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.location-gardemeuble.fr/img/ariane_s.png",
    alt: "",
    width: "10",
    height: "25"
  })
], -1)
const _hoisted_306 = [
  _hoisted_303,
  _hoisted_304,
  _hoisted_305
]
const _hoisted_307 = { key: 1 }
const _hoisted_308 = ["innerHTML"]
const _hoisted_309 = {
  key: 0,
  class: "city-desc more"
}
const _hoisted_310 = ["aria-expanded"]
const _hoisted_311 = /*#__PURE__*/_createTextVNode(" Voir plus ")
const _hoisted_312 = ["innerHTML"]
const _hoisted_313 = { id: "right" }
const _hoisted_314 = {
  key: 0,
  class: "map"
}
const _hoisted_315 = /*#__PURE__*/_createElementVNode("button", { class: "button black" }, " Voir sur la carte ", -1)
const _hoisted_316 = [
  _hoisted_315
]
const _hoisted_317 = { key: 1 }
const _hoisted_318 = {
  key: 0,
  class: "miniform no-mobile",
  id: "links"
}
const _hoisted_319 = /*#__PURE__*/_createElementVNode("h3", null, "Besoin de cartons de déménagement à prix imbattable ?", -1)
const _hoisted_320 = ["href"]
const _hoisted_321 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.location-gardemeuble.fr/img/logo_carton.jpg",
  alt: "Cartons de Déménagement",
  width: "250",
  height: "83"
}, null, -1)
const _hoisted_322 = /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " Vos cartons de déménagement pas chers, livrés chez vous en 24 heures ", -1)
const _hoisted_323 = /*#__PURE__*/_createElementVNode("div", { class: "fleche" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.location-gardemeuble.fr/img/ariane_s.png",
    alt: "",
    width: "10",
    height: "25"
  })
], -1)
const _hoisted_324 = [
  _hoisted_321,
  _hoisted_322,
  _hoisted_323
]
const _hoisted_325 = {
  key: 1,
  class: "articles"
}
const _hoisted_326 = /*#__PURE__*/_createElementVNode("h3", null, " Ces articles pourraient vous intéresser ! ", -1)
const _hoisted_327 = ["innerHTML"]
const _hoisted_328 = ["href"]
const _hoisted_329 = /*#__PURE__*/_createTextVNode(" Lire la suite ")
const _hoisted_330 = {
  key: 2,
  class: "articles"
}
const _hoisted_331 = ["innerHTML"]
const _hoisted_332 = ["href"]
const _hoisted_333 = /*#__PURE__*/_createTextVNode(" Lire la suite ")
const _hoisted_334 = { key: 2 }
const _hoisted_335 = { key: 0 }
const _hoisted_336 = { class: "normal" }
const _hoisted_337 = /*#__PURE__*/_createTextVNode(" Le loyer d'un box de stockage est estimé à ")
const _hoisted_338 = { class: "green" }
const _hoisted_339 = /*#__PURE__*/_createTextVNode(", par m")
const _hoisted_340 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_341 = {
  key: 1,
  class: "price-array"
}
const _hoisted_342 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, " (centres partenaires et non partenaires dans un rayon de 30 km) ", -1)
const _hoisted_343 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createTextVNode("Taille en m"),
    /*#__PURE__*/_createElementVNode("sup", null, "2")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, "Fourchette basse"),
  /*#__PURE__*/_createElementVNode("th", null, "Prix moyen"),
  /*#__PURE__*/_createElementVNode("th", null, "Fourchette haute")
], -1)
const _hoisted_344 = { key: 1 }
const _hoisted_345 = /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, " Nous n'avons malheureusement pas de données pour cette ville. ", -1)
const _hoisted_346 = [
  _hoisted_345
]
const _hoisted_347 = /*#__PURE__*/_createElementVNode("small", null, " Tarifs indicatifs en TTC ne tenant pas compte des promotions en cours. ", -1)
const _hoisted_348 = /*#__PURE__*/_createTextVNode(" afin de fournir à tout moment les estimations les plus fiables et les plus transparentes. ")
const _hoisted_349 = {
  key: 2,
  class: "miniform"
}
const _hoisted_350 = /*#__PURE__*/_createElementVNode("h3", null, "Besoin d'aide sur votre taille de box garde-meubles ? ", -1)
const _hoisted_351 = /*#__PURE__*/_createElementVNode("p", null, "Estimez gratuitement la taille de votre box", -1)
const _hoisted_352 = {
  key: 3,
  class: "miniform no-mobile",
  id: "links"
}
const _hoisted_353 = /*#__PURE__*/_createElementVNode("h3", null, "Besoin de cartons de déménagement à prix imbattable ?", -1)
const _hoisted_354 = ["href"]
const _hoisted_355 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.location-gardemeuble.fr/img/logo_carton.jpg",
  alt: "Cartons de Déménagement",
  width: "250",
  height: "83"
}, null, -1)
const _hoisted_356 = /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " Vos cartons de déménagement pas chers, livrés chez vous en 24 heures ", -1)
const _hoisted_357 = /*#__PURE__*/_createElementVNode("div", { class: "fleche" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.location-gardemeuble.fr/img/ariane_s.png",
    alt: "",
    width: "10",
    height: "25"
  })
], -1)
const _hoisted_358 = [
  _hoisted_355,
  _hoisted_356,
  _hoisted_357
]
const _hoisted_359 = {
  key: 4,
  class: "articles"
}
const _hoisted_360 = /*#__PURE__*/_createElementVNode("h3", null, " Nos conseils d'expert sur le déménagement ", -1)
const _hoisted_361 = ["innerHTML"]
const _hoisted_362 = ["href"]
const _hoisted_363 = /*#__PURE__*/_createTextVNode(" Lire la suite ")
const _hoisted_364 = {
  key: 5,
  class: "articles"
}
const _hoisted_365 = /*#__PURE__*/_createElementVNode("h3", null, " Nos conseils d'expert sur le stockage ", -1)
const _hoisted_366 = ["innerHTML"]
const _hoisted_367 = ["href"]
const _hoisted_368 = /*#__PURE__*/_createTextVNode(" Lire la suite ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_Map = _resolveComponent("Map")!
  const _component_Actions = _resolveComponent("Actions")!
  const _component_CalculModal = _resolveComponent("CalculModal")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (this.store.state.search)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Header),
          (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
            type: "application/ld+json",
            "data-pagespeed-no-transform": ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": \"AggregateRating\", \"itemReviewed\": { \"@type\": \"LocalBusiness\", \"name\": \"" + _toDisplayString("Garde meubles " + this.store.state.search.city.name) + "\" }, \"ratingValue\": \"" + _toDisplayString(this.getAverageRatingForAllResults()) + "\", \"bestRating\": \"" + _toDisplayString(5) + "\", \"worstRating\": \"" + _toDisplayString(this.getWorstRatingForAllResults()) + "\", \"reviewCount\": \"" + _toDisplayString(this.getTotalAvisForAllResults()) + "\", \"ratingCount\": \"" + _toDisplayString(this.getTotalAvisForAllResults()) + "\" } ", 1)
            ]),
            _: 1
          })),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("section", _hoisted_3, [
              _createVNode(_component_SearchBar, {
                search_page: true,
                tarif: this.props.tarif
              }, null, 8, ["tarif"]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("select", {
                      name: "size",
                      id: "size",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.filters.size) = $event))
                    }, _hoisted_12, 512), [
                      [_vModelSelect, this.filters.size]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("select", {
                      name: "type",
                      id: "type",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.filters.type) = $event))
                    }, _hoisted_18, 512), [
                      [_vModelSelect, this.filters.type]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _withDirectives(_createElementVNode("select", {
                      name: "carton",
                      id: "carton",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.filters.carton) = $event))
                    }, _hoisted_23, 512), [
                      [_vModelSelect, this.filters.carton]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives(_createElementVNode("select", {
                      name: "promo",
                      id: "promo",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.filters.promo) = $event))
                    }, _hoisted_28, 512), [
                      [_vModelSelect, this.filters.promo]
                    ])
                  ])
                ], 512), [
                  [_vShow, this.filters_shown || this.store.getters.isDesktop]
                ]),
                (this.store.getters.isMobile)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (this.filters_shown = !this.filters_shown)),
                      class: "filter-show"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: this.filters_shown ? 'caret-up' : 'caret-down'
                      }, null, 8, ["icon"]),
                      _createElementVNode("div", null, _toDisplayString(this.filters_shown ? "Masquer" : "Afficher") + " les filtres de recherche ", 1),
                      _createVNode(_component_font_awesome_icon, {
                        icon: this.filters_shown ? 'caret-up' : 'caret-down'
                      }, null, 8, ["icon"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (this.store.state.search.tarif)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_29, " Tarif garde meuble " + _toDisplayString(this.store.state.search.city.name) + " " + _toDisplayString(this.store.state.search.city.postcode), 1))
                : _createCommentVNode("", true),
              (!this.store.state.search.tarif)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_30, " Garde meuble " + _toDisplayString(this.store.state.search.city.name) + " " + _toDisplayString(this.store.state.search.city.postcode), 1))
                : _createCommentVNode("", true),
              (this.store.state.search.tarif)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_31, " Obtenez le meilleur prix garde meuble des " + _toDisplayString(this.store.state.search.near.length) + " centres de location de box vers " + _toDisplayString(this.store.state.search.city.name), 1))
                : _createCommentVNode("", true),
              (!this.store.state.search.tarif)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_32, " Louez un garde meubles dans " + _toDisplayString(this.store.state.search.near.length) + " sites de location de box sur " + _toDisplayString(this.store.state.search.city.name), 1))
                : _createCommentVNode("", true),
              (this.store.state.search.search_sentence)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 4,
                    id: "search-sentence",
                    class: _normalizeClass(["search-sentence", this.sentence_open ? '' : 'sentence-height'])
                  }, _toDisplayString(this.store.state.search.search_sentence), 3))
                : _createCommentVNode("", true),
              (!this.sentence_open && this.store.state.search.search_sentence)
                ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (this.sentence_open = true), ["prevent"])),
                      class: "dark-link",
                      "aria-expanded": this.sentence_open,
                      "aria-controls": "search-sentence"
                    }, [
                      _createElementVNode("small", null, [
                        _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                        _hoisted_35
                      ])
                    ], 8, _hoisted_34)
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("p", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("b", null, _toDisplayString(this.getFilteredResults().length), 1),
                _hoisted_38
              ], 512), [
                [_vShow, this.filtersActive()]
              ]),
              _createElementVNode("div", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getFilteredResults(), (gm, key) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("a", {
                          href: gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url )
                        }, [
                          (typeof gm.images[0] !== 'undefined')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: gm.images[0].url,
                                alt: gm.images[0].title,
                                width: "360",
                                height: "203",
                                style: {"height":"auto !important"}
                              }, null, 8, _hoisted_44))
                            : _createCommentVNode("", true),
                          (typeof gm.images[0] === 'undefined')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_43),
                        (!this.store.state.search.tarif && gm.size_range && gm.size_range?.min)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(gm.size_range.all.length) + " box à louer de " + _toDisplayString(gm.size_range.min) + " à " + _toDisplayString(gm.size_range.max) + " " + _toDisplayString(gm.size_range.unit), 1))
                          : _createCommentVNode("", true),
                        (this.store.state.search.tarif)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ) + '#rdv',
                              class: "button box-button black"
                            }, _hoisted_50, 8, _hoisted_47))
                          : _createCommentVNode("", true),
                        (this.store.state.search.tarif)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              onClick: ($event: any) => (gm.num_shown = true),
                              class: "button box-button black"
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: "phone" }),
                              (!gm.num_shown)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Afficher le numéro"))
                                : _createCommentVNode("", true),
                              (gm.num_shown)
                                ? (_openBlock(), _createElementBlock("b", _hoisted_53, _toDisplayString(gm.phone[0]), 1))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_51))
                          : _createCommentVNode("", true),
                        (this.store.state.search.tarif)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 3,
                              href: gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                              class: "button box-button"
                            }, _hoisted_56, 8, _hoisted_54))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          href: gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                          style: {"display":"flex","align-items":"flex-start"}
                        }, [
                          _createElementVNode("div", {
                            class: "only-mobile",
                            style: _normalizeStyle({
                        width: '110px',
                        minWidth: '110px',
                        height: '110px',
                        minHeight: '110px',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        marginRight: '0.5em',
                        backgroundImage: typeof gm.images[0] !== 'undefined' ? 'url(\''+( gm.images[0].url.replace( '/thumb/', '/mini/' ) )+'\')' : 'url(\'https://www.location-gardemeuble.fr/img/no-img.gif\')'
                      })
                          }, null, 4),
                          _createElementVNode("div", null, [
                            _createElementVNode("b", _hoisted_58, [
                              _createElementVNode("span", null, _toDisplayString(gm.name), 1),
                              _createElementVNode("span", _hoisted_59, [
                                (this.store.state.search.tarif && gm.size_range && gm.size_range?.min)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(gm.size_range.all.length) + " box à louer de " + _toDisplayString(gm.size_range.min) + " à " + _toDisplayString(gm.size_range.max) + " " + _toDisplayString(gm.size_range.unit), 1))
                                  : _createCommentVNode("", true),
                                (!this.store.state.search.tarif && gm.box_promo)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      title: this.TOOLTIP_PROMO,
                                      class: "green-promo",
                                      style: {"font-size":"1em !important"}
                                    }, _toDisplayString(gm.box_promo), 9, _hoisted_61))
                                  : (!this.store.state.search.tarif && gm.has_promo)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 2,
                                        title: this.TOOLTIP_PROMO,
                                        class: "green-promo",
                                        style: {"font-size":"1em !important"}
                                      }, " Promotion ", 8, _hoisted_62))
                                    : _createCommentVNode("", true)
                              ]),
                              (this.store.getters.isDesktop && gm.has_price_stud)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "no-mobile",
                                    width: "27",
                                    style: {"max-width":"27px"},
                                    src: _imports_0,
                                    alt: "Etudiant",
                                    title: this.TOOLTIP_STUDENT
                                  }, null, 8, _hoisted_63))
                                : _createCommentVNode("", true),
                              (this.store.getters.isDesktop && gm.demenageur)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    class: "no-mobile",
                                    width: "27",
                                    style: {"max-width":"27px"},
                                    src: _imports_1,
                                    alt: "Déménageur",
                                    title: this.TOOLTIP_CAMION
                                  }, null, 8, _hoisted_64))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("b", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                (!this.store.state.search.tarif && gm.box_promo)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      title: this.TOOLTIP_PROMO,
                                      class: "green-promo",
                                      style: {"display":"inline-block !important","margin":"0 0.25em","margin-left":"0"}
                                    }, _toDisplayString(gm.box_promo), 9, _hoisted_67))
                                  : (gm.has_promo)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        title: this.TOOLTIP_PROMO,
                                        class: "green-promo",
                                        style: {"display":"inline-block !important","margin":"0 0.25em","margin-left":"0"}
                                      }, " Promotion ", 8, _hoisted_68))
                                    : _createCommentVNode("", true),
                                (gm.has_price_stud)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 2,
                                      width: "27",
                                      style: {"max-width":"27px","max-height":"27px","margin":"0 0.25em"},
                                      src: _imports_0,
                                      alt: "Etudiant",
                                      title: this.TOOLTIP_STUDENT
                                    }, null, 8, _hoisted_69))
                                  : _createCommentVNode("", true),
                                (gm.demenageur)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 3,
                                      width: "27",
                                      style: {"max-width":"27px","max-height":"27px","margin":"0 0.25em"},
                                      src: _imports_1,
                                      alt: "Déménageur",
                                      title: this.TOOLTIP_CAMION
                                    }, null, 8, _hoisted_70))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (this.store.getters.isMobile && gm.size_range && gm.size_range?.min)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(gm.size_range.all.length) + " box à louer de " + _toDisplayString(gm.size_range.min) + " à " + _toDisplayString(gm.size_range.max) + " " + _toDisplayString(gm.size_range.unit), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              ((gm.address + ' ' + gm.city.name + ' ' +  gm.city.postcode).length < 40)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(this.store.state.search.tarif ? "" : (gm.address)) + " " + _toDisplayString(gm.city.name) + " " + _toDisplayString(gm.city.postcode), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                    _createTextVNode(_toDisplayString(this.store.state.search.tarif ? "" : (gm.address)) + " ", 1),
                                    (!this.store.state.search.tarif)
                                      ? (_openBlock(), _createElementBlock("br", _hoisted_74))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(gm.city.name) + " " + _toDisplayString(gm.city.postcode), 1)
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_75, _toDisplayString(gm?.keyword_m ?? gm?.keyword) + " " + _toDisplayString(this.store.state.search.city.name), 1),
                            (gm.avis.length > 0 && this.store.getters.isMobile)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                  _createElementVNode("a", {
                                    href: gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ) + '#avis',
                                    onClick: ($event: any) => (this.store.state.counter( 'avis', gm.id, () => '' ))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "star",
                                      style: {"color":"#F9B937","filter":"drop-shadow(0 0 0.1em black)"}
                                    }),
                                    _createElementVNode("span", _hoisted_78, [
                                      _createTextVNode(_toDisplayString(gm.note.toFixed( 1 )) + " / 5.0 (", 1),
                                      _createElementVNode("span", _hoisted_79, _toDisplayString(gm.avis.length) + " avis", 1),
                                      _hoisted_80
                                    ])
                                  ], 8, _hoisted_77)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_57),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, _toDisplayString(this.store.state.search.tarif ? "" : gm.address) + " " + _toDisplayString(gm.city.name) + " " + _toDisplayString(gm.city.postcode), 1),
                          _createElementVNode("div", _hoisted_83, _toDisplayString(gm.keyword) + " " + _toDisplayString(this.store.state.search.city.name), 1)
                        ]),
                        (gm.avis.length > 0 && this.store.getters.isDesktop)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                              _createElementVNode("a", {
                                href: gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ) + '#avis',
                                onClick: ($event: any) => (this.store.state.counter( 'avis', gm.id, () => '' ))
                              }, [
                                _withDirectives(_createElementVNode("div", _hoisted_86, [
                                  _createTextVNode(" \"" + _toDisplayString(gm.avis[0].short) + "\" ", 1),
                                  _hoisted_87
                                ], 512), [
                                  [_vShow, this.store.getters.isDesktop && gm.avis[0].short.length > 0]
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_88, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                                      return _createVNode(_component_font_awesome_icon, {
                                        key: index,
                                        icon: "star"
                                      })
                                    }), 64))
                                  ]),
                                  _createElementVNode("div", {
                                    class: "gold",
                                    style: _normalizeStyle({ width : ( gm.note / 5 * 100 ) + '%' })
                                  }, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                                      return _createVNode(_component_font_awesome_icon, {
                                        key: index,
                                        icon: "star"
                                      })
                                    }), 64))
                                  ], 4)
                                ]),
                                _createElementVNode("span", null, _toDisplayString(gm.note.toFixed( 1 )) + " / 5.0 (" + _toDisplayString(gm.avis.length) + " avis)", 1)
                              ], 8, _hoisted_85)
                            ]))
                          : _createCommentVNode("", true),
                        (!this.store.state.search.tarif)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              class: "no-mobile",
                              innerHTML: gm.description
                            }, null, 8, _hoisted_89))
                          : _createCommentVNode("", true),
                        (this.store.state.search.tarif && this.boxes(gm.boxes).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                              (this.store.state.search.tarif)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(this.boxes(gm.boxes), (box, index) => {
                                    return (_openBlock(), _createElementBlock("div", null, [
                                      _createElementVNode("a", {
                                        href: gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ) + '#box_' + box.id
                                      }, [
                                        _createElementVNode("table", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("b", {
                                                  innerHTML: box.type_name
                                                }, null, 8, _hoisted_92),
                                                _hoisted_93,
                                                _createElementVNode("span", {
                                                  innerHTML: box.size
                                                }, null, 8, _hoisted_94),
                                                _createElementVNode("span", {
                                                  innerHTML: box.unit.replace('3', '<sup>3</sup>').replace('2', '<sup>2</sup>')
                                                }, null, 8, _hoisted_95)
                                              ]),
                                              (box.promo)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(box.promo), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (box.prices.normal === 0 || !box.prices.show)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_97, _hoisted_99))
                                              : _createCommentVNode("", true),
                                            (box.prices.normal > 0 && box.prices.show)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_100, [
                                                  _createElementVNode("b", _hoisted_101, _toDisplayString(box.prices.normal) + " € ", 1),
                                                  _hoisted_102,
                                                  (box.prices.strike)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                        _createElementVNode("del", null, "au lieu de " + _toDisplayString(box.prices.strike) + " €", 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_font_awesome_icon, { icon: "caret-right" })
                                              ])
                                            ])
                                          ])
                                        ])
                                      ], 8, _hoisted_91)
                                    ]))
                                  }), 256))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_104, [
                          (!this.store.state.search.tarif)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: gm.url.replace( 'https://www.location-gardemeuble.fr/', this.store.state.base_url ),
                                class: "button box-button",
                                style: {"display":"inline-block !important","margin":"auto","padding":"0.7em 1.5em"}
                              }, _hoisted_107, 8, _hoisted_105))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 512), [
                      [_vShow, key >= this.gm_start && key < (this.gm_per_page + this.gm_start)]
                    ])
                  ]))
                }), 256)),
                _withDirectives(_createElementVNode("div", _hoisted_108, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.pages, (index) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(index - 1 === this.gm_start / _ctx.gm_per_page ? 'current' : ''),
                      onClick: ($event: any) => {this.gm_start = (index - 1) * _ctx.gm_per_page; _ctx.window.scrollTo({top: 0, behavior: 'smooth'});}
                    }, _toDisplayString(index), 11, _hoisted_109))
                  }), 256))
                ], 512), [
                  [_vShow, this.pages > 1 && this.getFilteredResults().length > 0]
                ]),
                _withDirectives(_createElementVNode("div", null, _hoisted_111, 512), [
                  [_vShow, this.getFilteredResults().length <= 0]
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  _hoisted_114,
                  (this.store.state.search.tarif)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                        _createElementVNode("article", _hoisted_116, [
                          _createElementVNode("div", _hoisted_117, [
                            _createElementVNode("h3", {
                              style: {"font-size":"1.1em"},
                              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (this.opened_faqs[666] = !this.opened_faqs[666]), ["prevent"])),
                              itemprop: "name"
                            }, [
                              _createTextVNode(" Quel est le prix d'un box à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                              (this.opened_faqs[666] === true)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: "caret-up"
                                  }))
                                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: "caret-down"
                                  }))
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_118, [
                              _createElementVNode("p", _hoisted_119, [
                                _createTextVNode(" Les boxes proposés par location-gardemeuble.fr à " + _toDisplayString(this.store.state.search.city.name) + ", ont des tailles de ", 1),
                                _createElementVNode("b", null, [
                                  _createTextVNode(_toDisplayString(this.boxPriceLowest().size) + " m", 1),
                                  _hoisted_120
                                ]),
                                _hoisted_121,
                                _createElementVNode("b", null, [
                                  _createTextVNode(_toDisplayString(this.boxBiggest().size) + " m", 1),
                                  _hoisted_122
                                ]),
                                _hoisted_123,
                                _createElementVNode("b", null, [
                                  _createTextVNode(_toDisplayString(this.boxPriceLowest().price) + "€", 1),
                                  _hoisted_124,
                                  _createTextVNode(_toDisplayString(this.boxBiggest().price) + "€", 1)
                                ]),
                                _hoisted_125
                              ])
                            ], 512), [
                              [_vShow, this.opened_faqs[666] === true]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    (!this.store.state.search.tarif)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                          _createElementVNode("section", null, [
                            (this.store.state.search.mensuel.moyenne > 0 && Object.keys( this.store.state.search.mensuel ).length > 2)
                              ? (_openBlock(), _createElementBlock("article", _hoisted_127, [
                                  _createElementVNode("h3", {
                                    style: {"font-size":"1.1em"},
                                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (this.opened_faqs[0] = !this.opened_faqs[0]), ["prevent"])),
                                    itemprop: "name"
                                  }, [
                                    _createTextVNode(" Quel prix pour un box de " + _toDisplayString(Object.keys( this.store.state.search.mensuel )[2]) + " m2 à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                    (this.opened_faqs[0] === true)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          icon: "caret-up"
                                        }))
                                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 1,
                                          icon: "caret-down"
                                        }))
                                  ]),
                                  _withDirectives(_createElementVNode("div", _hoisted_128, [
                                    _createElementVNode("p", _hoisted_129, [
                                      (typeof Object.keys( this.store.state.search.mensuel )[2] !== 'undefined')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_130, " Le prix d'un box de stockage de " + _toDisplayString(Object.keys( this.store.state.search.mensuel )[2]) + " m2 à " + _toDisplayString(this.store.state.search.city.name) + " est en moyenne de " + _toDisplayString(Object.values( this.store.state.search.mensuel )[2].mid) + " euros par mois. ", 1))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" Le tarif d'un garde-meubles peut varier en fonction de la durée, des promotions en cours, de l'emplacement. La taille d'un centre de stockage à " + _toDisplayString(this.store.state.search.city.name) + " peut varier, le plus souvent, entre " + _toDisplayString(this.boxPriceLowest().size) + " et " + _toDisplayString(this.boxPriceHighest().size) + " m2. Les prix varient de " + _toDisplayString(this.boxPriceLowest().price) + " euros à " + _toDisplayString(this.boxPriceHighest().price) + " euros. Utilisez notre ", 1),
                                      _hoisted_131,
                                      _hoisted_132
                                    ])
                                  ], 512), [
                                    [_vShow, this.opened_faqs[0] === true]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("article", _hoisted_133, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (this.opened_faqs[1] = !this.opened_faqs[1]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Comment louer un box à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                (this.opened_faqs[1] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_134, [
                                _createElementVNode("div", _hoisted_135, [
                                  _createTextVNode(" Pour louer un box à " + _toDisplayString(this.store.state.search.city.name) + " avec le site Location-gardemeuble.fr, suivez ces étapes simples : ", 1),
                                  _createElementVNode("ul", _hoisted_136, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("b", null, "Recherchez un emplacement à " + _toDisplayString(this.store.state.search.city.name) + " et ses alentours :", 1),
                                      _createTextVNode(" Utilisez l'outil de recherche sur le site pour trouver un emplacement de garde-meuble près de chez vous. Vous pouvez saisir votre ville « " + _toDisplayString(this.store.state.search.city.name) + " » ou votre code postal « " + _toDisplayString(this.store.state.search.city.postcode) + " » pour afficher les options disponibles en région " + _toDisplayString(this.store.state.search.region?.name) + ". ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_137,
                                      _createTextVNode(" Parcourez les différentes options de stockage disponibles aux environs de " + _toDisplayString(this.store.state.search.city.name) + ", en tenant compte de la taille du box, des tarifs et des fonctionnalités proposées. ", 1)
                                    ]),
                                    _hoisted_138,
                                    _createElementVNode("li", null, [
                                      _hoisted_139,
                                      _createTextVNode(" Si le box à " + _toDisplayString(this.store.state.search.city.name) + " est disponible aux dates souhaitées, vous pouvez généralement le réserver en ligne en fournissant vos informations personnelles. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_140,
                                      _createTextVNode(" Une fois votre réservation confirmée, vous devrez signer un contrat de location en ligne ou sur place lorsque vous vous rendez au garde-meuble dans le département " + _toDisplayString(this.store.state.search.departement?.name) + ". ", 1)
                                    ]),
                                    _hoisted_141,
                                    _createElementVNode("li", null, [
                                      _hoisted_142,
                                      _createTextVNode(" Préparez vos biens à stocker et organisez votre déménagement vers le garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + ". ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_143,
                                      _createTextVNode(" Une fois sur place, utilisez les codes d'accès fournis pour accéder à votre box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " et entreposer vos biens en toute sécurité. ", 1)
                                    ])
                                  ]),
                                  _createTextVNode(" En suivant ces étapes, vous pourrez louer un box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " avec facilité et commodité grâce au site Location-gardemeuble.fr. ", 1)
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[1] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_144, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (this.opened_faqs[2] = !this.opened_faqs[2]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Quel est la durée d’engagement pour louer un box à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                (this.opened_faqs[2] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_145, [
                                _createElementVNode("p", _hoisted_146, " La location d’un box est d’un mois minimum pour la plupart des centres de stockage à " + _toDisplayString(this.store.state.search.city.name) + ". Ensuite, votre contrat est renouvelé tacitement pour que vous continuiez à disposer de votre espace en toute tranquillité jusqu'à ce que vous n'en ayez plus besoin. Idéal pour du stockage temporaire ou sur les longues durées. ", 1)
                              ], 512), [
                                [_vShow, this.opened_faqs[2] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_147, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (this.opened_faqs[3] = !this.opened_faqs[3]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Quels sont les types de biens que je peux stocker dans un box à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                (this.opened_faqs[3] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_148, [
                                _createElementVNode("p", _hoisted_149, " Vous pouvez stocker une grande variété de biens dans un box à " + _toDisplayString(this.store.state.search.city.name) + ". Meubles, cartons. Matériel et équipement divers : outils, équipement de bricolage, matériel de camping, équipement de sport, etc. Matériaux, Articles saisonniers : vêtements d'hiver ou d'été, équipement de sport, décorations de Noël, etc. Appareils électroménagers : réfrigérateurs, lave-linge, sèche-linge, lave-vaisselle, fours, etc. Documents et archives : documents professionnels, archives personnelles, papiers administratifs, etc. Objets personnels : vêtements, chaussures, sacs, jouets, souvenirs, etc. Véhicules : voitures, motos, vélos, bateaux, caravanes, etc. ", 1)
                              ], 512), [
                                [_vShow, this.opened_faqs[3] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_150, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (this.opened_faqs[4] = !this.opened_faqs[4]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Y a-t-il des restrictions sur les articles que je peux stocker dans un garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                (this.opened_faqs[4] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_151, [
                                _createElementVNode("div", _hoisted_152, [
                                  _createTextVNode(" Oui, il peut y avoir des restrictions sur les articles que vous pouvez stocker dans un box de stockage à " + _toDisplayString(this.store.state.search.city.name) + ". Ces restrictions varient d'un établissement à l'autre, mais généralement, les éléments suivants sont interdits ou soumis à des limitations : ", 1),
                                  _hoisted_153,
                                  _createTextVNode(" Avant de louer un garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + ", il est important de consulter les politiques spécifiques de l'établissement pour vous assurer que vous comprenez les restrictions et les limitations sur ce que vous pouvez stocker. ", 1)
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[4] === true]
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_154, [
                          _createElementVNode("section", null, [
                            _createElementVNode("article", _hoisted_155, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (this.opened_faqs[0] = !this.opened_faqs[0]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Les tarifs varient-ils en fonction de la taille du box à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                (this.opened_faqs[0] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_156, [
                                _createElementVNode("p", _hoisted_157, [
                                  _createTextVNode(" Oui, généralement, les tarifs de location d'un garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + " varient en fonction de la taille du box. Les garde-meubles proposent souvent une gamme de tailles de box, allant des plus petites unités, adaptées à quelques articles ou à des meubles de petite taille, aux plus grandes unités capables de stocker des meubles volumineux ou une grande quantité de biens. ", 1),
                                  _hoisted_158,
                                  _createTextVNode(" En règle générale, plus la taille du box est grande, plus le tarif de location mensuel sera élevé. Cependant, les tarifs peuvent varier d'un fournisseur à l'autre, et certains offrent des prix dégressifs lorsque vous louez un box de stockage plus grand pour une durée plus longue. Il est donc important de comparer les tarifs aux alentours de " + _toDisplayString(this.store.state.search.city.name) + " et les options disponibles pour trouver la solution qui correspond le mieux à vos besoins et à votre budget. ", 1)
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[0] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_159, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (this.opened_faqs[1] = !this.opened_faqs[1]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Les tarifs à " + _toDisplayString(this.store.state.search.city.name) + " sont-ils dégressifs en fonction de la durée de location ? ", 1),
                                (this.opened_faqs[1] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_160, [
                                _createElementVNode("p", _hoisted_161, [
                                  _createTextVNode(" Oui, dans de nombreux cas, les tarifs de location de garde-meubles à " + _toDisplayString(this.store.state.search.city.name) + " sont dégressifs en fonction de la durée de location. Les fournisseurs de boxes à louer peuvent offrir des tarifs réduits pour les locations à long terme, comme un mois, trois mois, six mois ou un an. En général, plus la durée de location est longue, plus le prix mensuel moyen est bas. ", 1),
                                  _hoisted_162,
                                  _createTextVNode(" Cela peut être avantageux si vous avez besoin de stocker vos biens pendant une période prolongée dans le département " + _toDisplayString(this.store.state.search.departement?.name) + ". Cependant, il est essentiel de comparer les tarifs à " + _toDisplayString(this.store.state.search.city.name) + " avec le site Location-gardemeuble.fr ", 1)
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[1] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_163, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (this.opened_faqs[2] = !this.opened_faqs[2]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _hoisted_164,
                                (this.opened_faqs[2] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_165, [
                                _createElementVNode("p", _hoisted_166, [
                                  _createTextVNode(" Oui, de nombreux fournisseurs de garde-meubles à " + _toDisplayString(this.store.state.search.city.name) + " et aux alentours proposent des promotions ou des réductions spéciales pour attirer de nouveaux clients. Ces offres peuvent inclure des réductions sur les tarifs de location pour les premiers mois, des offres de stockage gratuites pendant une période déterminée, des tarifs réduits pour les locations à long terme, ou d'autres avantages comme la fourniture gratuite de matériel d'emballage. ", 1),
                                  _hoisted_167,
                                  _createTextVNode(" Il est judicieux de consulter les offres promotionnelles disponibles auprès de différents fournisseurs sur le site Location-gardemeuble.fr et de comparer les prix et les conditions pour trouver la meilleure offre adaptée à vos besoins de stockage à " + _toDisplayString(this.store.state.search.city.name) + ". Assurez-vous également de lire attentivement les termes et conditions de l'offre pour comprendre toutes les conditions associées. ", 1)
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[2] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_168, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (this.opened_faqs[3] = !this.opened_faqs[3]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Quels sont les modes de paiement acceptés pour le loyer du garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                (this.opened_faqs[3] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_169, [
                                _createElementVNode("div", _hoisted_170, [
                                  _createTextVNode(" Les modes de paiement acceptés pour le loyer d'un box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " peuvent varier d'un fournisseur à un autre. Cependant, la plupart des centres de self-stockage sur le site Location-gardemeuble.fr acceptent généralement les modes de paiement suivants : ", 1),
                                  _createElementVNode("ul", _hoisted_171, [
                                    _hoisted_172,
                                    _hoisted_173,
                                    _createElementVNode("li", null, [
                                      _hoisted_174,
                                      _createTextVNode(" Vous pouvez également être en mesure de payer votre loyer en effectuant un virement bancaire directement sur le compte du fournisseur de garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + ". Assurez-vous de disposer des informations bancaires correctes pour effectuer le virement. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_175,
                                      _createTextVNode(" Bien que de moins en moins courant, certains fournisseurs de box de rangement à " + _toDisplayString(this.store.state.search.city.name) + " acceptent encore les paiements par chèque. Cependant, cela peut entraîner des délais de traitement plus longs que d'autres méthodes de paiement. ", 1)
                                    ])
                                  ]),
                                  _createTextVNode(" Avant de choisir une solution de stockage à " + _toDisplayString(this.store.state.search.city.name) + ", il est important de vérifier quels modes de paiement sont acceptés et de choisir celui qui convient le mieux à vos préférences et à votre situation financière. ", 1)
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[3] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_176, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (this.opened_faqs[4] = !this.opened_faqs[4]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Quel est le tarif de location mensuel d'un box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                (this.opened_faqs[4] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_177, [
                                _createElementVNode("div", _hoisted_178, [
                                  _createTextVNode(" Le tarif de location mensuel d'un box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " peut varier en fonction de plusieurs facteurs, notamment : ", 1),
                                  _createElementVNode("ul", _hoisted_179, [
                                    _createElementVNode("li", null, [
                                      _hoisted_180,
                                      _createTextVNode(" Les tarifs peuvent varier en fonction de la taille du box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " que vous choisissez. Les boxes de plus grande taille auront généralement des tarifs plus élevés que les plus petits. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_181,
                                      _createTextVNode(" Les tarifs peuvent également varier en fonction de l'emplacement du box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " : centre-ville, périphérie, etc. Les garde-meubles situés dans des zones urbaines ou très demandées peuvent avoir des tarifs plus élevés que ceux situés dans des zones moins fréquentées. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_182,
                                      _createTextVNode(" Certaines enseignes à " + _toDisplayString(this.store.state.search.city.name) + " proposent des tarifs dégressifs pour les locations à long terme. Plus la durée de votre contrat de location est longue, plus le tarif mensuel peut être avantageux. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_183,
                                      _createTextVNode(" Certains propriétaires offrent des services supplémentaires tels que la sécurité renforcée, l'accès 24/7, la climatisation, etc. Ces services peuvent influencer le tarif mensuel de location à " + _toDisplayString(this.store.state.search.city.name) + ". ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_184,
                                      _createTextVNode(" Certains centres à " + _toDisplayString(this.store.state.search.city.name) + " proposent des promotions ou des réductions spéciales pour les nouveaux clients ou pour les locations à long terme. Cela peut vous permettre d'obtenir un tarif mensuel plus avantageux. ", 1)
                                    ])
                                  ]),
                                  _createTextVNode(" En général, les tarifs de location mensuelle d'un box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " peuvent varier de quelques dizaines à quelques centaines d'euros, en fonction des facteurs mentionnés ci-dessus. Il est recommandé de comparer les tarifs avec le site Location-gardemeuble.fr et les services proposés par différentes enseignes avant de faire votre choix. ", 1)
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[4] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_185, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (this.opened_faqs[5] = !this.opened_faqs[5]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Les tarifs à " + _toDisplayString(this.store.state.search.city.name) + " sont-ils ajustés en fonction de la saison ou de la demande ? ", 1),
                                (this.opened_faqs[5] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_186, [
                                _createElementVNode("div", _hoisted_187, [
                                  _createTextVNode(" Oui, dans certains cas, les tarifs de location de garde-meubles à " + _toDisplayString(this.store.state.search.city.name) + " peuvent être ajustés en fonction de la saison ou de la demande. Voici quelques points à considérer : ", 1),
                                  _createElementVNode("ul", _hoisted_188, [
                                    _createElementVNode("li", null, [
                                      _hoisted_189,
                                      _createTextVNode(" Par exemple, les déménagements sont souvent plus fréquents pendant les mois d'été, ce qui peut entraîner une augmentation de la demande de garde-meubles à " + _toDisplayString(this.store.state.search.city.name) + ". En conséquence, les tarifs de location peuvent être plus élevés pendant les périodes de forte demande. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_190,
                                      _createTextVNode(" Certains proposent des offres spéciales ou des promotions pendant certaines périodes de l'année pour attirer de nouveaux clients ou encourager les locations à long terme. Ces offres peuvent inclure des réductions sur les tarifs de location mensuels à " + _toDisplayString(this.store.state.search.city.name) + " ou des services supplémentaires gratuits. ", 1)
                                    ]),
                                    _hoisted_191,
                                    _createElementVNode("li", null, [
                                      _hoisted_192,
                                      _createTextVNode(" Des événements spéciaux tels que des salons, des foires ou des festivals peuvent également influencer la demande de garde-meubles dans une région donnée. Les tarifs de location à " + _toDisplayString(this.store.state.search.city.name) + " peuvent être ajustés en conséquence pendant ces périodes pour refléter la demande accrue. ", 1)
                                    ])
                                  ])
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[5] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_193, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (this.opened_faqs[6] = !this.opened_faqs[6]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Les tarifs sont-ils les mêmes pour tous les emplacements de garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + " ou varient-ils en fonction de la localisation ? ", 1),
                                (this.opened_faqs[6] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_194, [
                                _createElementVNode("div", _hoisted_195, [
                                  _createTextVNode(" Les tarifs de location de garde-meubles dans le département " + _toDisplayString(this.store.state.search.departement?.name) + " peuvent varier en fonction de la localisation de l'emplacement. Voici quelques facteurs qui peuvent influencer les différences de tarification : ", 1),
                                  _createElementVNode("ul", _hoisted_196, [
                                    _hoisted_197,
                                    _createElementVNode("li", null, [
                                      _hoisted_198,
                                      _createTextVNode(" Les tarifs de location à " + _toDisplayString(this.store.state.search.city.name) + " peuvent également être influencés par la demande locale de garde-meubles. Dans les zones où l'espace de stockage est limité et la demande est élevée, les tarifs peuvent être plus élevés pour refléter cette demande accrue. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_199,
                                      _createTextVNode(" Dans les marchés où il y a plusieurs concurrents, les tarifs peuvent être plus compétitifs. Les fournisseurs à " + _toDisplayString(this.store.state.search.city.name) + " peuvent ajuster leurs tarifs pour rester compétitifs sur le marché. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_200,
                                      _createTextVNode(" Les tarifs de location peuvent également varier en fonction des services et des installations offerts par les garde-meubles à " + _toDisplayString(this.store.state.search.city.name) + ". Par exemple, un centre de location de box de stockage individuel proposant des installations haut de gamme et des services supplémentaires peut facturer des tarifs plus élevés que ceux qui offrent des installations plus basiques. ", 1)
                                    ])
                                  ]),
                                  _hoisted_201
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[6] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_202, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (this.opened_faqs[7] = !this.opened_faqs[7]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Y a-t-il des tarifs spéciaux pour les entreprises à " + _toDisplayString(this.store.state.search.city.name) + " ou les besoins de stockage à long terme ? ", 1),
                                (this.opened_faqs[7] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_203, [
                                _createElementVNode("div", _hoisted_204, [
                                  _createTextVNode(" Oui, de nombreux centres de box de rangement à " + _toDisplayString(this.store.state.search.city.name) + " proposent des tarifs spéciaux pour les entreprises ou les besoins de stockage à long terme. Voici quelques exemples de tarifs spéciaux qui peuvent être disponibles à " + _toDisplayString(this.store.state.search.city.name) + " : ", 1),
                                  _createElementVNode("ul", _hoisted_205, [
                                    _createElementVNode("li", null, [
                                      _hoisted_206,
                                      _createTextVNode(" Certains fournisseurs proposent des tarifs préférentiels ou des offres spéciales pour les entreprises à " + _toDisplayString(this.store.state.search.city.name) + " qui ont besoin de stocker des biens ou des documents commerciaux. Ces tarifs peuvent être adaptés aux besoins spécifiques des entreprises, tels que des options de stockage à grande échelle ou des tarifs réduits pour les contrats à long terme. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_207,
                                      _createTextVNode(" Pour les entreprises ou les particuliers ayant besoin de stocker de grandes quantités de biens, certains fournisseurs proposent des tarifs réduits pour les volumes importants. Ces tarifs de gros peuvent être avantageux pour les entreprises qui ont besoin de stocker à " + _toDisplayString(this.store.state.search.city.name) + ", de grandes quantités de stocks ou de marchandises. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_208,
                                      _createTextVNode(" Les fournisseurs de garde-meubles à " + _toDisplayString(this.store.state.search.city.name) + " offrent souvent des tarifs réduits pour les contrats de location à long terme. Ces tarifs sont généralement appliqués aux locations de plusieurs mois ou années et peuvent offrir des économies significatives par rapport aux tarifs mensuels standard. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_209,
                                      _createTextVNode(" De nombreux fournisseurs à " + _toDisplayString(this.store.state.search.city.name) + " proposent des offres promotionnelles ou des remises spéciales pour attirer de nouveaux clients ou récompenser la fidélité des clients existants. Ces offres peuvent inclure des réductions sur les frais de location initiaux, des mois de location gratuits ou des services supplémentaires gratuits. ", 1)
                                    ])
                                  ])
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[7] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_210, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (this.opened_faqs[8] = !this.opened_faqs[8]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Les tarifs comprennent-ils l'accès aux installations de sécurité et autres équipements du garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                                (this.opened_faqs[8] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_211, [
                                _createElementVNode("div", _hoisted_212, [
                                  _createTextVNode(" Oui, généralement, les tarifs de location d'un box à " + _toDisplayString(this.store.state.search.city.name) + " comprennent l'accès aux installations de sécurité et aux équipements disponibles sur place. Voici ce qui est généralement inclus dans les tarifs : ", 1),
                                  _createElementVNode("ul", _hoisted_213, [
                                    _hoisted_214,
                                    _createElementVNode("li", null, [
                                      _hoisted_215,
                                      _createTextVNode(" Les tarifs à " + _toDisplayString(this.store.state.search.city.name) + " peuvent également inclure l'accès à des équipements de manutention tels que des chariots, des diables et des ascenseurs pour faciliter le chargement et le déchargement des biens dans le box. ", 1)
                                    ]),
                                    _hoisted_216,
                                    _createElementVNode("li", null, [
                                      _hoisted_217,
                                      _createTextVNode(" Les tarifs comprennent généralement l'accès aux installations du garde-meuble à " + _toDisplayString(this.store.state.search.city.name) + ", y compris les aires de stationnement, les zones de chargement et les zones de stockage. ", 1)
                                    ])
                                  ]),
                                  _createTextVNode(" En général, les tarifs de location mensuelle d'un box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " peuvent varier de quelques dizaines à quelques centaines d'euros, en fonction des facteurs mentionnés ci-dessus. Il est recommandé de comparer les tarifs avec le site Location-gardemeuble.fr et les services proposés par différentes enseignes avant de faire votre choix. ", 1)
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[8] === true]
                              ])
                            ]),
                            _createElementVNode("article", _hoisted_218, [
                              _createElementVNode("h3", {
                                style: {"font-size":"1.1em"},
                                onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (this.opened_faqs[9] = !this.opened_faqs[9]), ["prevent"])),
                                itemprop: "name"
                              }, [
                                _createTextVNode(" Existe-t-il des options d'assurance pour couvrir mes biens stockés à " + _toDisplayString(this.store.state.search.city.name) + ", et à quel prix ? ", 1),
                                (this.opened_faqs[9] === true)
                                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 0,
                                      icon: "caret-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                      key: 1,
                                      icon: "caret-down"
                                    }))
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_219, [
                                _createElementVNode("div", _hoisted_220, [
                                  _createTextVNode(" Oui, la plupart des fournisseurs à " + _toDisplayString(this.store.state.search.city.name) + " proposent des options d'assurance pour couvrir les biens stockés contre les dommages, le vol, l'incendie et d'autres risques potentiels. Voici quelques points à considérer concernant l'assurance pour vos biens stockés : ", 1),
                                  _createElementVNode("ul", _hoisted_221, [
                                    _createElementVNode("li", null, [
                                      _hoisted_222,
                                      _createTextVNode(" Certains centres de stockage à " + _toDisplayString(this.store.state.search.city.name) + " proposent une assurance de base incluse dans le tarif de location. Cela peut couvrir les biens jusqu'à un certain montant prédéterminé. Assurez-vous de comprendre les limites de couverture et les exclusions éventuelles de cette assurance. ", 1)
                                    ]),
                                    _createElementVNode("li", null, [
                                      _hoisted_223,
                                      _createTextVNode(" Vous pouvez généralement souscrire une assurance complémentaire pour augmenter la couverture de vos biens stockés à " + _toDisplayString(this.store.state.search.city.name) + ". Cela peut être particulièrement important si la valeur de vos biens dépasse les limites de couverture de l'assurance de base. ", 1)
                                    ]),
                                    _hoisted_224,
                                    _createElementVNode("li", null, [
                                      _hoisted_225,
                                      _createTextVNode(" Le coût de l'assurance supplémentaire à " + _toDisplayString(this.store.state.search.city.name) + " peut varier en fonction de divers facteurs, tels que la valeur des biens assurés, la durée de la couverture et les risques potentiels associés au stockage à " + _toDisplayString(this.store.state.search.city.name) + ". Il est important de comparer les options d'assurance proposées par différents fournisseurs pour trouver celle qui correspond le mieux à vos besoins et à votre budget. ", 1)
                                    ]),
                                    _hoisted_226
                                  ]),
                                  _hoisted_227,
                                  _createElementVNode("a", _hoisted_228, " souscrire une assurance pour un box à " + _toDisplayString(this.store.state.search.city.name), 1),
                                  _hoisted_229
                                ])
                              ], 512), [
                                [_vShow, this.opened_faqs[9] === true]
                              ])
                            ])
                          ])
                        ]))
                  ]),
                  (this.store.state.search.tarif && typeof this.store.state.search.city.faq.questions_tarif !== 'undefined' && this.store.state.search.city.faq.questions_tarif.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.search.city.faq.questions_tarif, (question, index) => {
                          return (_openBlock(), _createElementBlock("article", _hoisted_231, [
                            (question && question.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                  _createElementVNode("h3", {
                                    style: {"font-size":"1.1em"},
                                    onClick: _withModifiers(($event: any) => (this.opened_faqs[100+index] = !this.opened_faqs[100+index]), ["prevent"]),
                                    itemprop: "name"
                                  }, [
                                    _createTextVNode(_toDisplayString(question.replace( "✅", "" )) + " ", 1),
                                    (this.opened_faqs[100+index] === true)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          icon: "caret-up"
                                        }))
                                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 1,
                                          icon: "caret-down"
                                        }))
                                  ], 8, _hoisted_233),
                                  _withDirectives(_createElementVNode("div", _hoisted_234, [
                                    _createElementVNode("p", {
                                      itemprop: "text",
                                      style: {"line-height":"140%"},
                                      innerHTML: this.store.state.search.city.faq.answers_tarif[index]
                                    }, null, 8, _hoisted_235)
                                  ], 512), [
                                    [_vShow, this.opened_faqs[100+index] === true]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (this.store.state.search.tarif && this.store.state.search?.desc?.trim().length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
                        _createElementVNode("article", _hoisted_237, [
                          _createElementVNode("div", _hoisted_238, [
                            _createElementVNode("h3", {
                              style: {"font-size":"1.1em"},
                              onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (this.opened_faqs[300] = !this.opened_faqs[300]), ["prevent"])),
                              itemprop: "name"
                            }, [
                              _createTextVNode(" Combien coûte un garde meuble sécurisé vers " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                              (this.opened_faqs[300] === true)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: "caret-up"
                                  }))
                                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: "caret-down"
                                  }))
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_239, [
                              _createElementVNode("p", {
                                itemprop: "text",
                                style: {"line-height":"140%"},
                                innerHTML: this.store.state.search.desc
                              }, null, 8, _hoisted_240)
                            ], 512), [
                              [_vShow, this.opened_faqs[300] === true]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!this.store.state.search.tarif && typeof this.store.state.search.city.faq.questions !== 'undefined' && this.store.state.search.city.faq.questions.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.search.city.faq.questions, (question, index) => {
                          return (_openBlock(), _createElementBlock("article", _hoisted_242, [
                            (question && question.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                  _createElementVNode("h3", {
                                    style: {"font-size":"1.1em"},
                                    onClick: _withModifiers(($event: any) => (this.opened_faqs[200+index] = !this.opened_faqs[200+index]), ["prevent"]),
                                    itemprop: "name"
                                  }, [
                                    _createTextVNode(_toDisplayString(question.replace( "✅", "" )) + " ", 1),
                                    (this.opened_faqs[200+index] === true)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          icon: "caret-up"
                                        }))
                                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 1,
                                          icon: "caret-down"
                                        }))
                                  ], 8, _hoisted_244),
                                  _withDirectives(_createElementVNode("div", _hoisted_245, [
                                    _createElementVNode("p", {
                                      itemprop: "text",
                                      style: {"line-height":"140%"},
                                      innerHTML: this.store.state.search.city.faq.answers[index]
                                    }, null, 8, _hoisted_246)
                                  ], 512), [
                                    [_vShow, this.opened_faqs[200+index] === true]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (!this.store.state.search.tarif)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.search.faqs, (question, index) => {
                          return (_openBlock(), _createElementBlock("article", _hoisted_248, [
                            (question && question.title && question.title.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                  _createElementVNode("h3", {
                                    style: {"font-size":"1.1em"},
                                    onClick: _withModifiers(($event: any) => (this.opened_faqs[300+index] = !this.opened_faqs[300+index]), ["prevent"]),
                                    itemprop: "name"
                                  }, [
                                    _createTextVNode(_toDisplayString(question.title) + " ", 1),
                                    (this.opened_faqs[300+index] === true)
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          icon: "caret-up"
                                        }))
                                      : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 1,
                                          icon: "caret-down"
                                        }))
                                  ], 8, _hoisted_250),
                                  _withDirectives(_createElementVNode("div", _hoisted_251, [
                                    _createElementVNode("div", {
                                      itemprop: "text",
                                      style: {"line-height":"140%"},
                                      innerHTML: question.text
                                    }, null, 8, _hoisted_252)
                                  ], 512), [
                                    [_vShow, this.opened_faqs[300+index] === true]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_253, [
                  (this.store.state.search.tarif && this.charts)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_255, " Comparaison des prix moyens des box à " + _toDisplayString(this.store.state.search.city.name), 1),
                          _createVNode(_component_Bar, {
                            chartData: this.charts.tarif.data,
                            chartOptions: this.charts.tarif.options,
                            style: {"width":"100%","max-width":"min(1000px, 95vw)","height":"300px","margin":"auto"}
                          }, null, 8, ["chartData", "chartOptions"]),
                          _createElementVNode("p", _hoisted_256, [
                            (this.getPriceChartData()[0] > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_257, [
                                  _hoisted_258,
                                  _createElementVNode("b", null, _toDisplayString(this.store.state.search?.city?.name), 1),
                                  _hoisted_259,
                                  _createElementVNode("b", null, _toDisplayString(this.getPriceChartData()[0]) + " euros", 1),
                                  _hoisted_260,
                                  _hoisted_261,
                                  _hoisted_262
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_263, " Nous n'avons pas de données sur les prix des box de stockage à " + _toDisplayString(this.store.state.search.city.name) + " pour le moment. ", 1)),
                            _hoisted_264,
                            _hoisted_265,
                            _createElementVNode("b", null, _toDisplayString(this.store.state.search?.departement?.name), 1),
                            _hoisted_266,
                            _createElementVNode("b", null, _toDisplayString(this.getPriceChartData()[1]) + " euros", 1),
                            _hoisted_267,
                            _hoisted_268,
                            _hoisted_269,
                            _hoisted_270,
                            _hoisted_271,
                            _createElementVNode("b", null, _toDisplayString(this.store.state.search?.region?.name), 1),
                            _hoisted_272,
                            _createElementVNode("b", null, _toDisplayString(this.getPriceChartData()[2]) + " euros", 1),
                            _hoisted_273,
                            _hoisted_274,
                            _hoisted_275
                          ]),
                          _createElementVNode("small", null, [
                            _hoisted_276,
                            _hoisted_277,
                            _createTextVNode(" Données basées sur les annonces de garde meubles à " + _toDisplayString(this.store.state.search.city.name) + " publiées sur Location-gardemeuble.fr en " + _toDisplayString(this.getMonthYear()) + ". ", 1)
                          ])
                        ]),
                        (this.getMonthSize() > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_278, [
                              _createElementVNode("h3", _hoisted_279, " Quelles sont les tailles de box les plus réservées à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                              _createVNode(_component_Bar, {
                                chartData: this.charts?.size_demande.data,
                                chartOptions: this.charts?.size_demande.options,
                                style: {"width":"100%","max-width":"min(1000px, 95vw)","height":"300px","margin":"auto"}
                              }, null, 8, ["chartData", "chartOptions"]),
                              _createElementVNode("p", _hoisted_280, [
                                _hoisted_281,
                                _createElementVNode("b", null, _toDisplayString(this.getMonth()), 1),
                                _createTextVNode(", la taille de box la plus demandée à " + _toDisplayString(this.store.state.search.city.name) + " est habituellement de ", 1),
                                _createElementVNode("b", null, [
                                  _createTextVNode(_toDisplayString(this.getMonthSize()) + "m", 1),
                                  _hoisted_282
                                ]),
                                _hoisted_283
                              ]),
                              _createElementVNode("small", null, " Données basées sur les annonces de garde meubles à " + _toDisplayString(this.store.state.search.city.name) + " publiées sur Location-gardemeuble.fr en " + _toDisplayString(this.getMonthYear()) + ". ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!this.store.state.search.tarif && this.charts)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_284, [
                        (Object.keys( this.getDateChartData() ).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                              _createElementVNode("h3", _hoisted_286, " Quelles sont les périodes d’affluences pour louer un box à " + _toDisplayString(this.store.state.search.city.name), 1),
                              _createVNode(_component_Bar, {
                                chartData: this.charts?.date.data,
                                chartOptions: this.charts?.date.options,
                                style: {"width":"100%","max-width":"min(1000px, 95vw)","height":"300px","margin":"auto"}
                              }, null, 8, ["chartData", "chartOptions"]),
                              _createElementVNode("p", _hoisted_287, " Vous retrouverez les mois les plus chargés pour louer un box à " + _toDisplayString(this.store.state.search.city.name) + ". Ce qu'il faut retenir, c'est que si vous pouvez les éviter, vous pourrez généralement vous préserver de prix plus élevés et avoir plus de choix dans les tailles de box ! ", 1),
                              _createElementVNode("small", null, [
                                _hoisted_288,
                                _hoisted_289,
                                _createTextVNode(" Données basées sur les demandes de box à " + _toDisplayString(this.store.state.search.city.name) + " effectuées sur Location-gardemeuble.fr en " + _toDisplayString((new Date()).getFullYear() - 1) + ". ", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (Object.keys( this.getDateDemandeChartData() ).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_290, [
                              _createElementVNode("h3", _hoisted_291, " A quel moment les habitants de " + _toDisplayString(this.store.state.search.city.name) + " débutent leur recherche de box ? ", 1),
                              _createVNode(_component_Bar, {
                                chartData: this.charts?.date_demande.data,
                                chartOptions: this.charts?.date_demande.options,
                                style: {"width":"100%","max-width":"min(1000px, 95vw)","height":"300px","margin":"auto"}
                              }, null, 8, ["chartData", "chartOptions"]),
                              _createElementVNode("p", _hoisted_292, [
                                _createTextVNode(" Le mois où il y a le plus de demandes de renseignements sur les garde-meubles à " + _toDisplayString(this.store.state.search.city.name) + " est ", 1),
                                _createElementVNode("b", null, _toDisplayString(this.getMonthDemande()), 1),
                                _hoisted_293,
                                _hoisted_294,
                                _createTextVNode(" Le mois où il y a le moins de demandes de renseignements sur les garde-meubles à " + _toDisplayString(this.store.state.search.city.name) + " est ", 1),
                                _createElementVNode("b", null, _toDisplayString(this.getMonthDemande(false)), 1),
                                _hoisted_295
                              ]),
                              _createElementVNode("small", null, [
                                _hoisted_296,
                                _hoisted_297,
                                _createTextVNode(" Données basées sur les demandes de box à " + _toDisplayString(this.store.state.search.city.name) + " effectuées sur Location-gardemeuble.fr en " + _toDisplayString((new Date()).getFullYear() - 1) + ". ", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", null, " Location garde meuble " + _toDisplayString(this.store.state.search.city.name) + " : " + _toDisplayString(this.store.state.search.tarif ? "prix" : "") + " des espaces de stockage à proximité ", 1),
                  _createElementVNode("div", _hoisted_298, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.search.cities, (city, index) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        (index > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: this.store.state.search.tarif ? city.url_t : city.url,
                              title: (this.store.state.search.tarif ? city.keyword_t : city.keyword ) + ' ' + city.name
                            }, _toDisplayString(this.store.state.search.tarif ? city.keyword_t : city.keyword) + " " + _toDisplayString(city.name), 9, _hoisted_299))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ])
                ]),
                (this.store.getters.isMobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_300, [
                      _hoisted_301,
                      _createElementVNode("a", {
                        href: this.store.state.base_url + 'carton-de-demenagement',
                        target: "_blank",
                        rel: "noopener"
                      }, _hoisted_306, 8, _hoisted_302)
                    ]))
                  : _createCommentVNode("", true),
                (!this.store.state.search.tarif && this.store.state.search.city.text)
                  ? (_openBlock(), _createElementBlock("article", _hoisted_307, [
                      _createElementVNode("h3", null, " Location box " + _toDisplayString(this.store.state.search.city.name) + " : selfstockage, box de stockage et box à louer sécurisé ", 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["city-desc", this.desc_open ? '' : 'desc-height'])
                      }, [
                        _createElementVNode("p", {
                          style: {"line-height":"140%"},
                          innerHTML: this.store.state.search.city.text
                        }, null, 8, _hoisted_308)
                      ], 2),
                      (!this.desc_open)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_309, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (this.desc_open = true), ["prevent"])),
                              class: "dark-link",
                              "aria-expanded": this.desc_open,
                              "aria-controls": "search-sentence"
                            }, [
                              _createElementVNode("small", null, [
                                _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                                _hoisted_311
                              ])
                            ], 8, _hoisted_310)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  innerHTML: this.store.state.search.sentence
                }, null, 8, _hoisted_312)
              ])
            ]),
            _createElementVNode("section", _hoisted_313, [
              (( this.store.getters.isMobile && this.store.state.map_shown ) || this.store.getters.isDesktop)
                ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                    (!this.store.state.map_shown && this.store.getters.isDesktop)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "no-mobile",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (this.store.state.map_shown = true))
                        }, _hoisted_316))
                      : _createCommentVNode("", true),
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        (this.store.state.map_shown)
                          ? (_openBlock(), _createBlock(_component_Map, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (this.store.state.search.tarif)
                ? (_openBlock(), _createElementBlock("div", _hoisted_317, [
                    (this.store.getters.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_318, [
                          _hoisted_319,
                          _createElementVNode("a", {
                            href: this.store.state.base_url + 'carton-de-demenagement',
                            target: "_blank",
                            rel: "noopener"
                          }, _hoisted_324, 8, _hoisted_320)
                        ]))
                      : _createCommentVNode("", true),
                    (this.store.state.search.articles.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_325, [
                          _hoisted_326,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.search.articles, (article) => {
                            return (_openBlock(), _createElementBlock("article", null, [
                              _createElementVNode("h3", null, _toDisplayString(article.title), 1),
                              _createElementVNode("p", {
                                innerHTML: article.text
                              }, null, 8, _hoisted_327),
                              _createElementVNode("div", null, [
                                _createElementVNode("a", {
                                  href: article.url
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                                  _hoisted_329
                                ], 8, _hoisted_328)
                              ])
                            ]))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true),
                    (this.store.state.search.guide_question.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_330, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.search.guide_question, (article) => {
                            return (_openBlock(), _createElementBlock("article", null, [
                              _createElementVNode("h3", null, _toDisplayString(article.title), 1),
                              _createElementVNode("p", {
                                innerHTML: article.text
                              }, null, 8, _hoisted_331),
                              _createElementVNode("div", null, [
                                _createElementVNode("a", {
                                  href: article.url
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                                  _hoisted_333
                                ], 8, _hoisted_332)
                              ])
                            ]))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!this.store.state.search.tarif)
                ? (_openBlock(), _createElementBlock("div", _hoisted_334, [
                    (this.store.state.search.mensuel.moyenne > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_335, [
                          _createElementVNode("h3", null, " Quel est le prix d'un garde meuble à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                          _createElementVNode("h3", _hoisted_336, [
                            _hoisted_337,
                            _createElementVNode("b", _hoisted_338, _toDisplayString(this.store.state.search.mensuel.moyenne) + "€ par mois", 1),
                            _hoisted_339,
                            _hoisted_340,
                            _createTextVNode(", en moyenne, en " + _toDisplayString(this.getMonthYear()) + ". ", 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (this.store.state.search.mensuel.moyenne > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_341, [
                          _createElementVNode("h3", null, " Guide des prix et tarifs d'un garde meuble à " + _toDisplayString(this.store.state.search.city.name) + " ? ", 1),
                          _hoisted_342,
                          _createElementVNode("table", null, [
                            _hoisted_343,
                            (Object.keys(this.store.state.search.mensuel).length > 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(this.store.state.search.mensuel, (price, index) => {
                                  return _withDirectives((_openBlock(), _createElementBlock("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(index), 1),
                                    _createElementVNode("td", null, _toDisplayString(price.low) + "€", 1),
                                    _createElementVNode("td", null, _toDisplayString(price.mid) + "€", 1),
                                    _createElementVNode("td", null, _toDisplayString(price.up) + "€", 1)
                                  ], 512)), [
                                    [_vShow, index > 0 && (index <= 10 || this.store.state.search.price_shown )]
                                  ])
                                }), 256))
                              : _createCommentVNode("", true),
                            (Object.keys(this.store.state.search.mensuel).length <= 0)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_344, _hoisted_346))
                              : _createCommentVNode("", true)
                          ]),
                          (!this.store.state.search.price_shown && this.boxPriceHighest().size > 10)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => {this.store.state.search.price_shown = true;})
                              }, " Voir plus de prix "))
                            : _createCommentVNode("", true),
                          _hoisted_347,
                          _createElementVNode("p", null, [
                            _createTextVNode(" Les prix des espaces de stockage à " + _toDisplayString(this.store.state.search.city.name) + " sont calculés par Location-gardemeuble sur la base des données des locations communiquées par nos partenaires et des annonces de box sécurisés. Notre équipe d'experts travaille en permanence à l'amélioration des sources de prix ", 1),
                            _createElementVNode("b", null, "garde meuble " + _toDisplayString(this.store.state.search.city.name), 1),
                            _hoisted_348
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (this.store.getters.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_349, [
                          _hoisted_350,
                          _hoisted_351,
                          _createElementVNode("button", {
                            class: "button block",
                            onClick: _cache[26] || (_cache[26] = ($event: any) => {this.store.state.search.calc_shown = true;})
                          }, " Calculer votre taille de box ")
                        ]))
                      : _createCommentVNode("", true),
                    (this.store.getters.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_352, [
                          _hoisted_353,
                          _createElementVNode("a", {
                            href: this.store.state.base_url + 'carton-de-demenagement',
                            target: "_blank",
                            rel: "noopener"
                          }, _hoisted_358, 8, _hoisted_354)
                        ]))
                      : _createCommentVNode("", true),
                    (this.store.state.search.articles.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_359, [
                          _hoisted_360,
                          _createElementVNode("article", null, [
                            _createElementVNode("h3", null, _toDisplayString(this.store.state.search.articles[0].title), 1),
                            _createElementVNode("p", {
                              innerHTML: this.store.state.search.articles[0].text
                            }, null, 8, _hoisted_361),
                            _createElementVNode("div", null, [
                              _createElementVNode("a", {
                                href: this.store.state.search.articles[0].url
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                                _hoisted_363
                              ], 8, _hoisted_362)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (this.store.state.search.guide_question.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_364, [
                          _hoisted_365,
                          _createElementVNode("article", null, [
                            _createElementVNode("h3", null, _toDisplayString(this.store.state.search.guide_question[0].title), 1),
                            _createElementVNode("p", {
                              innerHTML: this.store.state.search.guide_question[0].text
                            }, null, 8, _hoisted_366),
                            _createElementVNode("div", null, [
                              _createElementVNode("a", {
                                href: this.store.state.search.guide_question[0].url
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "eye" }),
                                _hoisted_368
                              ], 8, _hoisted_367)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (this.store.getters.isMobile)
              ? (_openBlock(), _createBlock(_component_Actions, { key: 0 }))
              : _createCommentVNode("", true),
            _createVNode(_component_CalculModal)
          ]),
          _createVNode(_component_Footer)
        ]))
      : _createCommentVNode("", true)
  ]))
}